import SharedRiskTab from 'pages/mobile/Finance/shared/RiskTab';
import React from 'react';

import { useCreditLineOperationDetail } from '../context';

export interface RiskProps {
  requestId: string;
}

const Risk: React.FC<RiskProps> = () => {
  const { requestId } = useCreditLineOperationDetail();
  return <SharedRiskTab product="creditLine" requestId={requestId} />;
};

export default Risk;
